/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./common-xlz.vue?vue&type=template&id=4cf41056&scoped=true&"
import script from "./common-xlz.vue?vue&type=script&lang=ts&"
export * from "./common-xlz.vue?vue&type=script&lang=ts&"
import style0 from "./common-xlz.vue?vue&type=style&index=0&id=4cf41056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf41056",
  null
  
)

export default component.exports